@if(isAbbreviationShow){
    <div class="team-avatar" [ngClass]="{ 'team-abbreviation': pageName === 'teamLogo' }" [ngStyle]="{ 'backgroundColor': ths.getTeamColor(team, 'away') }">
        {{ team?.abbreviation ? team?.abbreviation : ths.getTeamInitials(team) }}
    </div>
} @else if(team?.profile_image) {
    <img [src]="team?.profile_image?.imageUrls?.medium || team?.profile_image"  (error)="isAbbreviationShow = true" />
} @else if(team?.type?.value === 'high-school') {
    <img [src]="team?.logo" (error)="isAbbreviationShow = true" />
} @else if (team?.organisations?.[0]?.organisationAbbreviation === 'ITA' && ITAlogo) {
    <ion-thumbnail slot="start">
        <img [src]="ITAlogo" (error)="isAbbreviationShow = true" />
    </ion-thumbnail>
} @else {
    <div class="team-avatar" [ngClass]="{ 'team-abbreviation': pageName === 'teamLogo' }" [ngStyle]="{ 'backgroundColor': ths.getTeamColor(team, 'away') }">
        {{ team?.abbreviation ? team?.abbreviation : ths.getTeamInitials(team) }}
    </div>
}